export enum EditableProfileUserDataType {
  NAME = 'name',
  LAST_NAME = 'last_name',
  PASSWORD = 'password',
  EMAIL = 'email',
}
